export default {
    'nav.dashboard': 'Dashboard',
    'nav.patients': 'Patients',
    'nav.appointments': 'Appointments',
    'nav.opd': 'Outpatients',
    'nav.ipd': 'Inpatients',
    'nav.billing': 'Billing',
    'nav.pharmacy': 'Pharmacy',
    'nav.lab': 'Laboratory',
    'nav.radiology': 'Radiology',
    'nav.accounts': 'Accounts',
    'nav.reports': 'Reports',
    'nav.settings': 'Settings',
    'nav.administration': 'Administration',
    'menu.profile': 'My profile',
    'menu.language': 'Language',
    'menu.sign_out': 'Sign out',
    'branch.all': 'All branches',
    'branch.label': 'Branch',
    'menu.change_password': 'Change password',
    'menu.security': 'Security',
    'menu.end_support_session': 'End the Owner session',
    'menu.account': 'Account',
    'branch.working_in': 'Working in',
    'branch.all_hint': 'Every branch you can reach',
    'branch.pick': 'Choose a branch',
    'banner.read_only': 'This account is read-only right now',
    'search.placeholder': 'Search patients by name, MRN or phone',
    'nav.item.dashboard': 'Dashboard',
    'nav.item.queue': 'My queue',
    'nav.item.triage': 'Triage',
    'nav.item.cosign': 'Co-sign',
    'nav.item.appointments': 'Appointments',
    'nav.item.schedules': 'Clinic hours',
    'nav.item.follow-ups': 'Follow-ups due',
    'nav.item.online-requests': 'Online requests',
    'nav.item.reports': 'Reports',
    'nav.item.patients': 'Patients',
    'nav.item.patients.new': 'Register',
    'nav.item.mrd': 'Medical records',
    'nav.item.consultations': 'Consultations',
    'nav.item.ipd.beds': 'Bed board',
    'nav.item.ipd.admissions': 'Admissions',
    'nav.item.ipd.locator': 'Find a patient',
    'nav.item.ipd.charge-rules': 'Ward charges',
    'nav.item.er': 'Emergency',
    'nav.item.ot': 'Operation theatre',
    'nav.item.blood-bank': 'Blood bank',
    'nav.item.maternity': 'Labour & delivery',
    'nav.item.therapy': 'Therapy units',
    'nav.item.dental': 'Dental',
    'nav.item.lab': 'Laboratory',
    'nav.item.lab.critical': 'Critical results',
    'nav.item.lab.home-collection': 'Home collection',
    'nav.item.lab.qc': 'Quality control',
    'nav.item.lab.catalogue': 'Test catalogue',
    'nav.item.lab.reports': 'Lab reports',
    'nav.item.radiology': 'Radiology',
    'nav.item.pharmacy': 'Pharmacy POS',
    'nav.item.inventory': 'Inventory',
    'nav.item.stock-control': 'Stock control',
    'nav.item.online-orders': 'Online orders',
    'nav.item.billing': 'Billing',
    'nav.item.billing.opd-dues': 'OPD dues',
    'nav.item.billing.shift': 'Cashier shift',
    'nav.item.billing.refunds': 'Refunds',
    'nav.item.billing.credit-customers': 'Credit customers',
    'nav.item.ipd.dues': 'Dues register',
    'nav.item.billing.charges': 'Services & prices',
    'nav.item.billing.settings': 'Billing settings',
    'nav.item.insurance': 'Insurance',
    'nav.item.accounting': 'Accounting',
    'nav.item.payables': 'Supplier payables',
    'nav.item.accounts.authority': 'Financial authority',
    'nav.item.accounts.doctor-share': 'Doctor share',
    'nav.item.accounting.payouts': 'Doctor payouts',
    'nav.item.ambulance': 'Ambulance',
    'nav.item.dietary': 'Kitchen',
    'nav.item.housekeeping': 'Housekeeping',
    'nav.item.tasks': 'Tasks',
    'nav.item.notifications': 'Notifications',
    'nav.item.feedback': 'Feedback',
    'nav.item.assets': 'Assets & maintenance',
    'nav.item.people': 'People',
    'nav.item.admin.branches': 'Branches & departments',
    'nav.item.admin.settings': 'Settings',
    'nav.item.admin.listing': 'Public listing',
    'nav.item.admin.audit': 'Audit log',
    'nav.item.support': 'Support',
    'nav.item.account.security': 'Security',
    'nav.section.today': 'Today',
    'nav.section.patients': 'Patients',
    'nav.section.clinical': 'Clinical',
    'nav.section.diagnostics': 'Diagnostics',
    'nav.section.pharmacy_stock': 'Pharmacy & stock',
    'nav.section.money': 'Money',
    'nav.section.accounts': 'Accounts',
    'nav.section.operations': 'Operations',
    'nav.section.people': 'People',
    'nav.section.administration': 'Administration',
    'nav.section.help': 'Help',
    'nav.section.your_account': 'Your account',
    'nav.group.inpatient': 'Inpatient',
    'nav.group.emergency_theatre': 'Emergency & theatre',
    'nav.group.specialty_units': 'Specialty units',
    'nav.group.billing_cashier': 'Billing & cashier',
    'nav.group.books': 'Books',
    'nav.item.ipd.wards': 'Ward tasks',
};
//# sourceMappingURL=shell.js.map